// import React, { Fragment, useEffect, useState } from "react";
// import { EditorState, Editor, convertToRaw, ContentState } from "draft-js";
// import draftToHtml from "draftjs-to-html";
// import htmlToDraft from "html-to-draftjs";
// import TimeYearMonthDate from "../containers/Date";

// const App = ({ convertContentToHTML, homeObj, save }) => {
//   const [editorState, setEditorState] = useState(() =>
//     EditorState.createEmpty(),
//   );

//   useEffect(() => {
//     if (homeObj.Text) {
//       const blocksFromHTML = htmlToDraft(homeObj.Text);
//       const state = ContentState.createFromBlockArray(
//         blocksFromHTML.contentBlocks,
//         blocksFromHTML.entityMap,
//       );
//       setEditorState((e) => EditorState.push(e, state));
//     }
//   }, []);

//   const handleEditorChange = (state) => {
//     setEditorState(state);
//     saveEditor();
//   };

//   const saveEditor = () => {
//     const currentContentAsHTML = draftToHtml(
//       convertToRaw(editorState.getCurrentContent()),
//     );
//     convertContentToHTML(currentContentAsHTML, "Text", homeObj.Id);
//   };

//   return (
//     <Fragment>
//       <Editor
//         editorState={editorState}
//         onChange={handleEditorChange}
//         wrapperClassName="wrapper-class"
//         editorClassName="editor-class"
//         toolbarClassName="toolbar-class"
//       />
//       <input
//         type="date"
//         value={homeObj.FromDate?.split("T")[0]}
//         onChange={(e) =>
//           convertContentToHTML(e.target.value, "FromDate", homeObj.Id)
//         }
//       />
//       <input
//         type="date"
//         value={homeObj.ToDate?.split("T")[0]}
//         onChange={(e) =>
//           convertContentToHTML(e.target.value, "ToDate", homeObj.Id)
//         }
//       />
//       <button onClick={() => save(homeObj.Id)}>שמירה</button>
//     </Fragment>
//   );
// };
// export default App;

import React, { useEffect, useState, useRef } from "react";
import { EditorState, Editor, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

const MyEditor = ({ convertContentToHTML, homeObj }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const isInitialized = useRef(false);
  const editorRef = useRef(null);

  useEffect(() => {
    if (!isInitialized.current && homeObj?.Text) {
      const blocksFromHTML = htmlToDraft(homeObj.Text);
      if (blocksFromHTML) {
        const contentState = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap,
        );
        setEditorState(EditorState.createWithContent(contentState));
      }
      isInitialized.current = true;
    }
  }, [homeObj.Text]);

  const focusEditor = () => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
  };

  const handleEditorChange = (state) => {
    setEditorState(state);
    const content = state.getCurrentContent();
    const rawContent = convertToRaw(content);
    const html = draftToHtml(rawContent);
    const isEmpty = !content.hasText() && rawContent.blocks.length <= 1;
    const finalHtml = isEmpty ? "" : html;
    convertContentToHTML(finalHtml);
  };

  return (
    <div
      className="editor-wrapper"
      onClick={focusEditor}
      style={{ cursor: "text" }}
    >
      <div className="editor-inner">
        <Editor
          ref={editorRef}
          editorState={editorState}
          onChange={handleEditorChange}
        />
      </div>
    </div>
  );
};

export default MyEditor;
